import Box from '@mui/material/Box'; 

export default function ErrorComponent() {
    return (
        <Box sx={{maxWidth: '100%', textAlign: "center", paddingY: 3, fontSize: '1.2rem'}}>
            Sorry, there was an error loading this info.
        </Box>
    );
}